import skill from "../../../../assets/images/recommandation/skillEmpty.svg"; // Placeholder Image
import "../styles/textRecommandationStyle.css";

export const SkillImage: React.FC = () => {
  return (
    <div className="SkillDiv">
      <img src={skill} alt="Placeholder" className="skillImage" />
      <div className="SkillupText">
        <p className="breakedtext">
          You do not have any system recommendation.
        </p>
        <p className="breakedtext">
          Please connect with your Mentor for seeking advice
        </p>
      </div>
    </div>
  );
};

export default SkillImage;
